import { Observable, Subject, BehaviorSubject } from "rxjs";

import { ICapsuleFolder, ICapsuleFile, IKendoCapsuleData } from "../../typings/board/Models";
import { CAPSULE_SERVICE, CapsuleService } from "../capsule/capsule.service";
import { Constant } from "../common/utils/constants";
import { CapsuleFolder, CapsuleFile } from "../capsule/capsuleFolder";

export const HIERARCHY_SERVICE: string = "HierarchyService";

export enum ModalCaller {
    MOVE=0, DUPLICATE=1
}

export class HierarchyService {
    private selectedKendoData: IKendoCapsuleData[];
    private rootFolder: BehaviorSubject<ICapsuleFolder>;
    private selectedFolder: BehaviorSubject<ICapsuleFolder>;
    public lastSelectedFolder: ICapsuleFolder;
    public rowSelected : BehaviorSubject<number>;
    private modalSelectedFolder : ICapsuleFolder;
    public modalCaller : Subject<ModalCaller>;

    static $inject = [CAPSULE_SERVICE, "$mdToast"];

    constructor(private capsuleService: CapsuleService,
        private $mdToast: ng.material.IToastService) {
        this.selectedFolder = new BehaviorSubject(null);
        this.rootFolder = new BehaviorSubject(null);
        this.selectedKendoData = [];
        this.modalCaller = new BehaviorSubject(null);
        this.rowSelected = new BehaviorSubject(0);
        var _self_: HierarchyService = this;
        this.capsuleService.$getExistingCapsule()
            .subscribe((value) => {
                _self_.rootFolder.next(value);
                if (_self_.lastSelectedFolder && _self_.lastSelectedFolder.relativePath) {
                    var newSelectedFolder: CapsuleFolder =
                        _self_.capsuleService.lookupCapsuleByPath(_self_.lastSelectedFolder.relativePath, value);
                    _self_.selectedFolder.next(newSelectedFolder);
                } else {
                    _self_.selectedFolder.next(value);
                }
            });

        this.selectedFolder.subscribe((value) => {
            this.lastSelectedFolder = Object.assign({}, value);
        });
    }

    public resetSelectedRows(): void {
        this.rowSelected.next(0);
    }

    public showToast(message:string):void {
        this.$mdToast.show(this.$mdToast.simple().textContent(message).position("top right"));
    }

    private buildCapsuleFromKendoData(selectedRows: IKendoCapsuleData[]): ICapsuleFolder {
        var returningCapsule: ICapsuleFolder =
            new CapsuleFolder(this.lastSelectedFolder.name, this.lastSelectedFolder.relativePath);

        if (selectedRows) {
            selectedRows.forEach(row => {
                if (!row.isFolder) {
                    returningCapsule.files.push(new CapsuleFile(row.fileFolderName, row.extension));
                } else {
                    var rowFolderPath: string =
                        this.lastSelectedFolder.subFolders.find(el => el.name === row.fileFolderName).relativePath;
                    returningCapsule.subFolders.push(new CapsuleFolder(row.fileFolderName, rowFolderPath));
                }
            });
        }
        return returningCapsule;
    }

    public stoppingAsyncOperation():void {
        this.capsuleService.stoppingAsyncOperation();
    }
    public updateKendoSelectedData(kendoSelectedData: IKendoCapsuleData[]): void {
        this.selectedKendoData = kendoSelectedData;
        this.rowSelected.next(this.selectedKendoData? this.selectedKendoData.length : this.selectedKendoData.length );
    }
    public $uploadCapsule(file: File, override: Boolean = null): Observable<number> {
        return this.capsuleService.$upload(this.lastSelectedFolder, file, override);
    }
    public $downloadCapsule(filename: string): void {
        this.capsuleService.$download(this.buildCapsuleFromKendoData(this.selectedKendoData), filename);
    }
    public $rename(filename: string): Observable<number> {
        return this.capsuleService.$rename(this.buildCapsuleFromKendoData(this.selectedKendoData), filename);
    }

    public $createFolder(destinationPath: string, folderName: string): Observable<number> {
        return this.capsuleService.$createFolder(destinationPath, folderName);
    }

    public $moveCapsule(destionationPath: string, override: Boolean = null): Observable<number> {
        return this.capsuleService.$move(this.buildCapsuleFromKendoData(this.selectedKendoData), destionationPath, override);
    }
    public $duplicateCapsule(destionationPath: string, override: Boolean = null): Observable<number> {
        return this.capsuleService.$duplicate(this.buildCapsuleFromKendoData(this.selectedKendoData), destionationPath, override);
    }
    public $delete(): Observable<number> {
        return this.capsuleService.$delete(this.buildCapsuleFromKendoData(this.selectedKendoData));
    }
    public showHideModal(): void {
        this.capsuleService.showHideModal();
    }
    public showMoveModal(): void {
        this.modalCaller.next(ModalCaller.MOVE);
        this.showHideModal();
    }
    public showDuplicateModal(): void {
        this.modalCaller.next(ModalCaller.DUPLICATE);
        this.showHideModal();
    }
    public updateSelectedFolder(selectedFolder: ICapsuleFolder): void {
        this.selectedFolder.next(selectedFolder);
    }
    public $getSelectedFolder(): Observable<ICapsuleFolder> {
        return this.selectedFolder.asObservable();
    }
    public $getRootFolder(): Observable<ICapsuleFolder> {
        return this.rootFolder.asObservable();
    }
}


// WEBPACK FOOTER //
// ./app/hierarchy-service/hierarchy.service.ts